module.exports = __webpack_public_path__ + "static/img/bt2.203f1925.png";